import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import Landing from "@/pages/Landing";
import GalleryPage from "@/pages/GalleryPage";
import TicketsPage from "@/pages/TicketsPage";
import PaymentReturn from "@/pages/PaymentReturn";
import AdminPage from "@/pages/AdminPage";
import RegisterPage from "@/pages/RegisterPage";
import RegisterHubPage from "@/pages/RegisterHubPage";
import SeminarAdultPage from "@/pages/SeminarAdultPage";
import SeminarKidsPage from "@/pages/SeminarKidsPage";
import FaqPage from "@/pages/FaqPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import { setLenis } from "@/lib/scroll";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer } from "@/components/site/CartDrawer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    setLenis(lenis);
    if (typeof window !== "undefined") window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
      <LenisBridge />
      <CartProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/tickets" element={<TicketsPage />} />
              <Route path="/payment-return" element={<PaymentReturn />} />
              <Route path="/register" element={<RegisterHubPage />} />
              <Route path="/register/amateur" element={<RegisterPage />} />
              <Route path="/register/seminar-adult" element={<SeminarAdultPage />} />
              <Route path="/register/seminar-kids" element={<SeminarKidsPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/refund-policy" element={<RefundPolicyPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </div>
          <CartDrawer />
          <WhatsAppFloat />
        </BrowserRouter>
      </CartProvider>
      <Toaster position="bottom-center" richColors />
    </ReactLenis>
  );
}

export default App;
